import { Component, OnInit } from '@angular/core';
import { MyDatePickerModule, IMyDpOptions } from 'mydatepicker';
import { CallBackEndService } from '../call-back-end.service';
import { IbRequest } from '../ib-request';
import { IbResponse } from '../ib-response';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { Angular2CsvModule } from 'angular2-csv';
declare var getHexAscii: any;
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';
import * as jsPDF from 'jspdf';
import { ToastrService } from 'ngx-toastr';
import 'rxjs/Rx';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Rx';
@Component({
  selector: 'app-cheque-book-request',
  templateUrl: './cheque-book-request.component.html',
  styleUrls: ['./cheque-book-request.component.css']
})
export class ChequeBookRequestComponent implements OnInit {
  accountNo : string = '';
  isLoad : boolean = false;
  addrType : string = '';
  showAddress : string = '';
  chequeBookRequestResp : any ;
  addressDetails : any ;
  noOfChqBooks : number;
  disabled : boolean =false;
  chequenoNotblank : string = '';
  chequenoNotSpace : string = '';
  chequenoNumber : string = '';
  chequenospecial : string = '';
  chequechar : string = '';
  ZeroOnly : string = '';
  isShow : string='show';
  userName ; string ='';
  custNo : string ;
  successMessage :  string = '';
  scoAccounts : any ;
  formError : string ;
  acctnoBlank : string='';
  addtypeblank : string ='';
 // noOfChqBooksforString : string ;
  ShowAddNCheque : string ;
  delivaryType : string ='';
  delivaryTypenoblank:string='';
  isDisabled : boolean = false;
  greaterSize: string ='';
  addressDetails1: any;
  noOfChequeBookErro: string;

  private _jsonURL = 'assets/SampleUrl.json';
  chequeBookRequestOnlyBranch: string;

  
  constructor(private webService: CallBackEndService,
    private http : HttpClient,
    private spinnerService: Ng4LoadingSpinnerService,private toastr: ToastrService) {
    this.userName =sessionStorage.getItem('storedUserName');
    this.custNo =sessionStorage.getItem('custNo');
    this.scoAccounts = JSON.parse(sessionStorage.getItem('scoAccounts'));
    this.noOfChqBooks= 1;

    this.getJSON().subscribe(data => {
      this.chequeBookRequestOnlyBranch = data.chequeBookRequestOnlyBranch;
     // console.log('urlfromJson----:-'+this.urlfromJson);
     });

  }
  public getJSON(): Observable<any> {
    return this.http.get(this._jsonURL);
  }
  ngOnInit() {
    }
  getAddressDetails(){
    console.log("add type---"+this.addrType)
    if(this.addrType===""||this.addrType===undefined)
    {
      this.addtypeblank="no";
      this.disabled=true;
    }
    else{
      const request: IbRequest = new IbRequest();
      let response: IbResponse = null;
      if(this.accountNo){
        this.acctnoBlank='';
        this.addtypeblank = '';
        this.disabled=false;
        this.addressDetails=this.addressDetails1;

       // this.isLoad=true;
        // this.spinnerService.show();
        console.log('this.showAddress : '+this.showAddress);
        console.log('Input : ' +getHexAscii("",this.accountNo+"Y"));
  //  const Details: any = {
  //       'userName':sessionStorage.getItem('storedUserName'),
  //     };


        // request.param1 = getHexAscii("",this.accountNo+"Y"+""+""+sessionStorage.getItem('storedUserName'));
        // request.param2 = this.accountNo;
        // request.param3 = 'Y';
        //  request.param4="";
        //   request.param5="";
        //  request.param6 =Details ;
        // //request.param5=this.addrType;
        // this.webService.getResponse(request, 'chequeBookRequest').subscribe((data: IbResponse) => {
        //   this.isLoad=false;
        //    this.spinnerService.hide();
        //   this.chequeBookRequestResp=data;
        //   if (this.chequeBookRequestResp.status === 'S101'){
        //     alert('Malicious Request Detected');
        //   }
        //   if(this.chequeBookRequestResp.status==='S200'){

        //     this.addressDetails= this.chequeBookRequestResp.param6;

        //   }else{
        //     // alert(this.chequeBookRequestResp.param1);
        //              this.toastr.error(this.chequeBookRequestResp.param1, 'Cheque Request',{'easeTime':0,'closeButton':true,'disableTimeOut':true});

        //   }
        // });
      }
    }
  }

  chequeBookRequest(){


    var reg=/[-!$%^&*()_+|~=`{}[:;<>?,.@#\]]/g;
    var regNum = /^[0-9]+$/;
    var regchar='/^[a-zA-Z]+$/'
    var regexpspace=/\s+/;
    var onlyZeroes=/^0*$/;
    //this.noOfChqBooksforString=this.noOfChqBooks+"";
    if(this.accountNo===undefined || this.accountNo==="")
    {
      this.acctnoBlank='no';
      this.disabled=true;
      this.formError='notValid';
    }else
    if(this.addrType===undefined || this.addrType==="")
    {
      this.addtypeblank='no';
      this.disabled=true;
      this.formError='notValid';
    }
    else if( (this.chequeBookRequestOnlyBranch==='no') && (this.delivaryType===undefined || this.delivaryType===""))
    {
      this.delivaryTypenoblank='no';
      this.disabled=true;
      this.formError='notValid';
    }


    // else
    // if(this.noOfChqBooks===undefined || this.noOfChqBooksforString==="")
    // {
    //   this.chequenoNotblank='no';
    //   this.disabled=true;
    //   this.formError='notValid';
    // }
    // else if(this.noOfChqBooksforString===" " || this.noOfChqBooksforString.indexOf(' ') !== -1)
    // {
    //   this.chequenoNotSpace='no';
    //   this.disabled=true;
    //   this.formError='notValid';
    // }
    // else if(!this.noOfChqBooksforString.match(regNum))
    // {
    //   this.chequenoNumber='no';
    //   this.disabled=true;
    //   this.formError='notValid';
    // }
    // else if(this.noOfChqBooksforString.match(reg))
    // {
    //   this.chequenospecial='no';
    //   this.disabled=true;
    //   this.formError='notValid';
    // }
    // else if(this.noOfChqBooks===0)
    // {
    //   this.ZeroOnly='no';
    //   this.disabled=true;
    //   this.formError='notValid';
    // }
    // else if(this.noOfChqBooksforString.match(onlyZeroes))
    // {
    //   this.ZeroOnly='no';
    //   this.disabled=true;
    //   this.formError='notValid';
    // }
    // else if(this.noOfChqBooks>=100)
    // {
    //   this.greaterSize='no';
    //   this.disabled=true;
    //   this.formError='notValid';
    // }
    else{
       if(this.validateNoOfChqBooks()){
      this.removechequenumber();
      this.isDisabled=true;
       this.spinnerService.show();
      const request: IbRequest = new IbRequest();
      let response: IbResponse = null;
      //if(this.accountNo && this.addrType && this.noOfChqBooks){
      this.disabled=true;
      this.isLoad=true;
       const Details: any = {
        'userName':sessionStorage.getItem('storedUserName'),
      };
     // request.param1 = getHexAscii("",this.accountNo+"N"+this.addrType+this.noOfChqBooks+"");
      request.param1 = getHexAscii("",this.accountNo+"N"+this.addrType+this.noOfChqBooks+""+sessionStorage.getItem('storedUserName'));
      request.param2 = this.accountNo;
      request.param3 = 'N';
      request.param4 = this.addrType;
      request.param5 = this.noOfChqBooks+"";
      request.param6=Details;
      /* if(this.getChequeBookNumber()!=='')
         {

       }
   else{*/
      this.webService.getResponse(request, 'chequeBookRequest').subscribe((data: IbResponse) => {
        this.isLoad=false;
         this.spinnerService.hide();
        this.chequeBookRequestResp=data;
        if (this.chequeBookRequestResp.status === 'S101'){
          alert('Malicious Request Detected');
        }
        else if(this.chequeBookRequestResp.status==='S200'){

          this.addressDetails= this.chequeBookRequestResp.param6;
          this.isDisabled=false;
          this.disabled=false;
          this.isShow='successpage';
          this.successMessage=this.chequeBookRequestResp.param1;

        }
        else{
         
          this.toastr.error(this.chequeBookRequestResp.param1, 'Cheque Request',{'easeTime':0,'closeButton':true,'disableTimeOut':true});
          this.isDisabled=false;
          this.disabled=false;
          /*this.message= this.chequeBookRequestResp.param1;*/
          //$modalInstance.dismiss('cancel');
        }
      });
      //}
    }
    }
  }

  // }


  validateNoOfChqBooks(){
    if(this.noOfChqBooks==undefined ){
      this.noOfChequeBookErro='yes';
      return false;
    }else if( this.noOfChqBooks==0){
      this.noOfChequeBookErro='zero';
      return false;
    }else if(this.noOfChqBooks>5){
      this.noOfChequeBookErro='exceededMaxVal';
      return false;
    }else{
      this.noOfChequeBookErro='';
      return true;
    }
  }
  changeValidateNoOfChqBooks(){
    this.noOfChequeBookErro='';
  }
  // getChequeBookNumber(): string
  // {
  //   //alert(" "+this.uname);
  //   var reg=/[-!$%^&*()_+|~=`{}[:;<>?,.@#\]]/g;
  //   var regNum = /^[0-9]+$/;
  //   var regchar='/^[a-zA-Z]+$/'
  //   var regexpspace=/\s+/;
  //   var onlyZeroes=/^0*$/;
  //   this.noOfChqBooksforString=this.noOfChqBooks+"";
  //   if(this.accountNo===undefined || this.accountNo==="")
  //   {
  //     this.acctnoBlank='no';
  //     this.disabled=true;
  //     this.formError='notValid';
  //   }else
  //   if(this.addrType===undefined || this.addrType==="")
  //   {
  //     this.addtypeblank='no';
  //     this.disabled=true;
  //     this.formError='notValid';
  //   }else
  //   if(this.delivaryType===undefined || this.delivaryType==="")
  //   {
  //     this.delivaryTypenoblank='no';
  //     this.disabled=true;
  //     this.formError='notValid';
  //   }else
  //   if(this.noOfChqBooks===undefined || this.noOfChqBooksforString==="")
  //   {
  //     this.chequenoNotblank='no';
  //     this.disabled=true;
  //     this.formError='notValid';
  //   }
  //   else if(this.noOfChqBooksforString===" " || this.noOfChqBooksforString.indexOf(' ') !== -1)
  //   {
  //     this.chequenoNotSpace='no';
  //     this.disabled=true;
  //     this.formError='notValid';
  //   }
  //   else if(!this.noOfChqBooksforString.match(regNum))
  //   {
  //     this.chequenoNumber='no';
  //     this.disabled=true;
  //     this.formError='notValid';
  //   }
  //   else if(this.noOfChqBooksforString.match(reg))
  //   {
  //     this.chequenospecial='no';
  //     this.disabled=true;
  //     this.formError='notValid';
  //   }
  //   else if(this.noOfChqBooks===0)
  //   {
  //     this.ZeroOnly='no';
  //     this.disabled=true;
  //     this.formError='notValid';
  //   }
  //   else if(this.noOfChqBooks>=100)
  //   {
  //     this.greaterSize='no';
  //     this.disabled=true;
  //     this.formError='notValid';
  //   }
  //   else if(this.noOfChqBooksforString.match(onlyZeroes))
  //   {
  //     this.ZeroOnly='no';
  //     this.disabled=true;
  //     this.formError='notValid';
  //   }
  //   return  this.formError;
  // }

  removechequenumber()
  {
    // this.addrType='';
    this.acctnoBlank='';
    this.chequenoNotblank='';
    this.chequenoNotSpace='';
    this.chequenoNumber='';
    this.chequenospecial='';
    this.chequechar='';
    this.ZeroOnly='';
    this.disabled=false;
    this.delivaryTypenoblank='';
    this.greaterSize='';
  }

  getAddChequeNo()
  {
    this.ShowAddNCheque='show';
    this.acctnoBlank='';


    const request: IbRequest = new IbRequest();
    let response: IbResponse = null;
    if(this.accountNo){
      this.acctnoBlank='';
      this.addtypeblank = '';
      this.disabled=false;
      this.isLoad=true;
       this.spinnerService.show();
      console.log('this.showAddress : '+this.showAddress);
      console.log('Input : ' +getHexAscii("",this.accountNo+"Y"));
 const Details: any = {
      'userName':sessionStorage.getItem('storedUserName'),
    };
   // request.param1 = getHexAscii("",this.accountNo+"Y"+""+"");  
    request.param1 = getHexAscii("",this.accountNo+"Y"+""+""+sessionStorage.getItem('storedUserName'));
      request.param2 = this.accountNo;
      request.param3 = 'Y';
       request.param4="";
        request.param5="";
       request.param6 =Details ;
      //request.param5=this.addrType;
      this.webService.getResponse(request, 'chequeBookRequest').subscribe((data: IbResponse) => {
        this.isLoad=false;
         this.spinnerService.hide();
        this.chequeBookRequestResp=data;
        if (this.chequeBookRequestResp.status === 'S101'){
          alert('Malicious Request Detected');
        }
        if(this.chequeBookRequestResp.status==='S200'){

          this.addressDetails1= this.chequeBookRequestResp.param6;

        }else{
          // alert(this.chequeBookRequestResp.param1);
                   this.toastr.error(this.chequeBookRequestResp.param1, 'Cheque Request',{'easeTime':0,'closeButton':true,'disableTimeOut':true});

        }
      });
    }



  }
  removeMsgDelType(){
    this.delivaryTypenoblank='';
  }

  validateAccNo()
  {
   if(this.accountNo===undefined || this.accountNo==="")
    {
      this.acctnoBlank='no';
      // this.disabled=true;
      this.formError='notValid';
    }
  }
  valiadteAddType()
  {
     if(this.addrType===""||this.addrType===undefined)
    {
      this.addtypeblank="no";
      this.disabled=true;
    }
  }
  validateDelType()
  {
    if(this.delivaryType===undefined || this.delivaryType==="")
     {
      this.delivaryTypenoblank='no';
      this.disabled=true;
      this.formError='notValid';
    }
  }
}



// WEBPACK FOOTER //
// D:/Sonali/JCCBViewOnlyProject/ViewOnlyJCCBfrontend19112022/InternetBanking6.3frontend/src/app/cheque-book-request/cheque-book-request.component.ts